import { StageDefinition } from './StageDefinition';

export const stage10: StageDefinition = {
    platforms: [
        [0, 0],
        [11.612903225806452, 0],
        [23.225806451612904, 0],
        [34.83870967741936, 0],
        [325.1612903225808, 0],
        [336.77419354838725, 0],
        [348.3870967741937, 0],
        [81.81818181818183, 2],
        [90.00000000000001, 2],
        [98.1818181818182, 2],
        [180.00000000000006, 2],
        [223.19999999999987, 3],
        [230.39999999999986, 3],
        [237.59999999999985, 3],
        [273.5999999999998, 3],
        [280.7999999999998, 3],
        [126.31578947368418, 4],
        [132.63157894736838, 4],
        [138.9473684210526, 4],
        [214.73684210526324, 4],
        [221.05263157894746, 4],
        [240.0000000000001, 4],
        [246.31578947368433, 4],
        [252.63157894736855, 4],
        [297.3913043478257, 6],
        [302.60869565217354, 6],
        [321.6000000000004, 7],
        [326.40000000000043, 7],
    ],
    traps: [
        [46.45161290322581, 0],
        [58.064516129032256, 0],
        [69.6774193548387, 0],
        [81.29032258064515, 0],
        [92.9032258064516, 0],
        [104.51612903225805, 0],
        [116.1290322580645, 0],
        [127.74193548387095, 0],
        [139.3548387096774, 0],
        [150.96774193548387, 0],
        [162.58064516129033, 0],
        [174.1935483870968, 0],
        [185.80645161290326, 0],
        [197.41935483870972, 0],
        [209.03225806451618, 0],
        [220.64516129032265, 0],
        [232.2580645161291, 0],
        [243.87096774193557, 0],
        [255.48387096774204, 0],
        [267.09677419354847, 0],
        [278.70967741935493, 0],
        [290.3225806451614, 0],
        [301.93548387096786, 0],
        [313.5483870967743, 0],
    ],
    stars: [
        [353, 7],
        [88, 3],
        [131, 5],
        [165, 5],
        [180, 5],
        [196, 5],
        [231, 4],
        [246, 5],
        [217, 5],
        [278, 4],
        [293, 8],
        [319, 8],
    ],
};
